module.exports = __webpack_public_path__ + "static/media/5.Highlighted Spread.242c40c7.jpg";